import {Notification} from "./ui/Notification"
import {NotificationService, INotificationService} from "./service/service"

const ns = NotificationService.getInstance() as INotificationService;

export {
    Notification as NotificationProvider,
    ns as NotificationService
}
